import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
} from "../components/ui";
import { useSeo } from "../lib/seo";
import { DemoForm } from "../components/DemoForm";
import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "30-minute live walkthrough",
  "Bring your own sample chart (de-identified)",
  "See flagged review + bundle render in real time",
  "BAA and DPA reviewed in advance",
];

export function Demo() {
  useSeo({
    title: "Request a demo — WeConsult Rx",
    description:
      "Request a 30-minute live demo of WeConsult Rx. Bring your own sample chart. See flagged reviews, bundle rendering, and Adobe Sign workflow live.",
    path: "/demo",
  });

  return (
    <Section>
      <Container>
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <Eyebrow>Request a demo</Eyebrow>
            <Heading level={1} className="mt-3">
              See WeConsult Rx in your workflow.
            </Heading>
            <Lede className="mt-6">
              30-minute call. Live walkthrough. Bring a sample chart.
            </Lede>
            <ul className="mt-8 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-ink-800">
                  <CheckCircle2 className="h-5 w-5 text-forest-700 mt-0.5" aria-hidden />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
            <div className="mt-10 rounded-xl bg-forest-50 p-5 text-sm text-ink-700">
              We never store the PHI in your sample chart. De-identification is
              available on call before any review begins.
            </div>
          </div>
          <Card className="md:p-10">
            <DemoForm source="demo-page" />
          </Card>
        </div>
      </Container>
    </Section>
  );
}
